import axios from "axios";
import { VueCookieNext } from 'vue-cookie-next'

export default axios.create({  
  baseURL: "/api",
  headers: {
    "Content-type": "application/json",
    // "Authorization": `Bearer ${VueCookieNext.getCookie('token')}`
  }
});